// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* chverons */
.chevron-container {
	display: flex;
	align-items: center;
}

.ff-chevron-left::before {
	padding-right: 2px;
}

.ff-chevron-right::before {
	padding-left: 2px;
}

.scroll-button {
	color: var(--toolbar-scroll-button-color);
	margin: 8px 3px;
	padding: 5px;
	font-size: 10px;
	border: 1px solid transparent;
	border-radius: 50px;
	height: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.scroll-button:hover {
	background: var(--toolbar-button-hover-color);
	cursor: pointer;
}

.greyedOut {
	opacity: 0.3;
}

.greyedOut:hover {
	background: transparent;
	cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/ui/assets/css/shared/common.css"],"names":[],"mappings":"AAAA,aAAa;AACb;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yCAAyC;CACzC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,6BAA6B;CAC7B,mBAAmB;CACnB,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,6CAA6C;CAC7C,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,uBAAuB;CACvB,eAAe;AAChB","sourcesContent":["/* chverons */\n.chevron-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.ff-chevron-left::before {\n\tpadding-right: 2px;\n}\n\n.ff-chevron-right::before {\n\tpadding-left: 2px;\n}\n\n.scroll-button {\n\tcolor: var(--toolbar-scroll-button-color);\n\tmargin: 8px 3px;\n\tpadding: 5px;\n\tfont-size: 10px;\n\tborder: 1px solid transparent;\n\tborder-radius: 50px;\n\theight: 10px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.scroll-button:hover {\n\tbackground: var(--toolbar-button-hover-color);\n\tcursor: pointer;\n}\n\n.greyedOut {\n\topacity: 0.3;\n}\n\n.greyedOut:hover {\n\tbackground: transparent;\n\tcursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
